module.exports = __webpack_public_path__ + "img/noCommunicationTest.af9e2eaa.svg";